import { render, staticRenderFns } from "./Eyes.vue?vue&type=template&id=7e537661&scoped=true&"
import script from "./Eyes.vue?vue&type=script&lang=js&"
export * from "./Eyes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e537661",
  null
  
)

export default component.exports